import * as React from "react";
import { Box, MenuItem, TextField, Grid, FormControlLabel, Checkbox } from "@mui/material";
import { useSelector } from "react-redux";
import Header from "components/Header";
import MasterReport from "./master";
import DetailsReport from "./details";
import AllUnits from "./units";
import IncomeExpenseSummaryV2 from "./IncomeExpenseSummaryV2";
import IncomeExpenseDetailsV2 from "./IncomeExpenseDetailsV2";
import IncomeExpenseUnitsV2 from "./IncomeExpenseUnitsV2";
import DefaultProperty from "components/DefaultProperty";
import OwnerWiseReport from "./OwnerWiseReport";
import OwnerAndMonthReport from "./OwnerAndMonthReport";
import RentedDueDates from "./RentedDueDates";
import PdcDueDates from "./PdcDueDates";
import ExpenseReport from "./Expense";
import OwnerWiseExpenseReport from "./OwnerWiseExpenseReport";
import UnitVacantReport from "./UnitVacantReport";
import UpcomingContractReport from "./UpcomingContractReport";
import CommonExpense from "./CommonExpense";
import RentalReport from "./RentalReport";
import DepositRegister from "./DepositRegister";
import TerminatedEmployees from "./TerminatedEmployees";

const Report = () => {
    const property = useSelector((state) => state.global.defaultProperty);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [filter, setFilter] = React.useState({ reportType: "type-1" });
    const [latest, setLatest] = React.useState(true);

    React.useEffect(() => { if (!property) setOpenDefaultProperty(true); }, []);
    const handleChange = (event) => { const { name, value } = event.target; setFilter((prev) => ({ ...prev, [name]: value })); };

    return (
        <>
            <Box sx={{ p: "24px 28px", mb: 3 }}>
                <Header title="Reports" subtitle="Financial & operational reports" />
                <Box sx={{ mt: 2.5, backgroundColor: "#fff", borderRadius: "8px", p: 2, border: "1px solid #dde2ea" }}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={4}>
                            <TextField select fullWidth label="Report Type" name="reportType" value={filter.reportType} onChange={handleChange} size="small">
                                <MenuItem value="type-1">Income & Expense - Summary</MenuItem>
                                <MenuItem value="type-2">Income & Expense - Details</MenuItem>
                                <MenuItem value="type-3">Income & Expense - Units</MenuItem>
                                <MenuItem value="type-4">Income & Expense - Owner wise</MenuItem>
                                <MenuItem value="type-5">Income & Expense - Owner & Month wise</MenuItem>
                                <MenuItem value="type-6">Default Rent Report</MenuItem>
                                <MenuItem value="type-7">PDC Due Report</MenuItem>
                                <MenuItem value="type-8">Expense report - property wise</MenuItem>
                                <MenuItem value="type-9">Total Expense report - by property and owner</MenuItem>
                                <MenuItem value="type-10">Unit vacant report - by property and owner</MenuItem>
                                <MenuItem value="type-11">Upcoming contract renewal report</MenuItem>
                                <MenuItem value="type-12">Common Expense report</MenuItem>
                                <MenuItem value="type-13">Statement Of Rental Income</MenuItem>
                                <MenuItem value="type-14">Deposit Register</MenuItem>
                                <MenuItem value="type-15">Terminated Employees</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={latest}
                                        onChange={(e) => setLatest(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Latest"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {!property && <DefaultProperty open={openDefaultProperty} onClose={() => setOpenDefaultProperty(false)} />}
            {filter.reportType === "type-1" && latest && <IncomeExpenseSummaryV2 />}
            {filter.reportType === "type-1" && !latest && <MasterReport />}
            {filter.reportType === "type-2" && latest && <IncomeExpenseDetailsV2 />}
            {filter.reportType === "type-2" && !latest && <DetailsReport />}
            {filter.reportType === "type-3" && latest && <IncomeExpenseUnitsV2 />}
            {filter.reportType === "type-3" && !latest && <AllUnits />}
            {filter.reportType === "type-4" && <OwnerWiseReport />}
            {filter.reportType === "type-5" && <OwnerAndMonthReport />}
            {filter.reportType === "type-6" && <RentedDueDates />}
            {filter.reportType === "type-7" && <PdcDueDates />}
            {filter.reportType === "type-8" && <ExpenseReport />}
            {filter.reportType === "type-9" && <OwnerWiseExpenseReport />}
            {filter.reportType === "type-10" && <UnitVacantReport />}
            {filter.reportType === "type-11" && <UpcomingContractReport />}
            {filter.reportType === "type-12" && <CommonExpense />}
            {filter.reportType === "type-13" && <RentalReport />}
            {filter.reportType === "type-14" && <DepositRegister />}
            {filter.reportType === "type-15" && <TerminatedEmployees />}
        </>
    );
};

export default Report;
